import { Option } from '@inrev/core';
import { IndemnityAgreementSignatureMethod } from '../enums.mjs';

const physicalSignatureStates = [
    "AK",
    "CA",
    "DC",
    "DE",
    "FL",
    "IL",
    "IN",
    "KS",
    "LA",
    "MO",
    "ND",
    "NJ",
    "NY",
    "PA",
    "RI",
    "VT",
];
const notaryOnlyStates = [
    "AK",
    "CA",
    "DC",
    "FL",
    "IL",
    "KS",
    "MO",
    "NJ",
    "NY",
    "PA",
    "VT",
];
const oneWitnessStates = ["DE", "IL", "VT"];
const twoWitnessesStates = ["FL", "NY", "PA"];
const getCompanySigningStates = (companies) => Array.from(new Set(companies.map((company) => Option.map(company.address, (address) => address.state))));
const getAllowedIndemnitySignatureMethods = (signingStates) => {
    const allowed = [IndemnityAgreementSignatureMethod.physical];
    if (signingStates.length > 0 &&
        signingStates.every((state) => Option.isSome(state) && !physicalSignatureStates.includes(state))) {
        allowed.push(IndemnityAgreementSignatureMethod.electronic);
    }
    return allowed;
};

export { getAllowedIndemnitySignatureMethods, getCompanySigningStates, notaryOnlyStates, oneWitnessStates, physicalSignatureStates, twoWitnessesStates };
